import React from 'react'
import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import { Tlas } from './Tlas'

if (process.env.REACT_APP_ENV === 'production') {
  console.log = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(<Tlas />)
